
import { AssetPreviewTabCommentsController } from './asset-preview-tab-comments.controller'

function assetPreviewTabComments () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      contextData: '<',
      location: '<',
      previewFlags: '=',
      task: '<'
    },
    templateUrl: '/core/directives/asset-preview-tab-comments/asset-preview-tab-comments.html?$$REVISION$$',
    controller: AssetPreviewTabCommentsController
  }
}
export { assetPreviewTabComments }
